<template>
  <el-card shadow="never" class="summary-card" v-loading="loading">
    <div class="summary-grid">
      <div class="summary-item given">
        <div class="summary-label">낸 부조금</div>
        <div class="summary-value">{{ formatNumber(summary.given_money.total) }}원</div>
        <div class="summary-count">{{ summary.given_money.count }}건</div>
      </div>
      <div class="summary-item received">
        <div class="summary-label">받은 부조금</div>
        <div class="summary-value">{{ formatNumber(summary.received_money.total) }}원</div>
        <div class="summary-count">{{ summary.received_money.count }}건</div>
      </div>
      <div class="summary-item given-flower">
        <div class="summary-label">보낸 화환</div>
        <div class="summary-value">{{ formatNumber(summary.given_flower.total) }}원</div>
        <div class="summary-count">{{ summary.given_flower.count }}건</div>
      </div>
      <div class="summary-item received-flower">
        <div class="summary-label">받은 화환</div>
        <div class="summary-value">{{ formatNumber(summary.received_flower.total) }}원</div>
        <div class="summary-count">{{ summary.received_flower.count }}건</div>
      </div>
    </div>
  </el-card>
</template>

<script setup>
defineProps({
  summary: {
    type: Object,
    default: () => ({
      given_money: { total: 0, count: 0 },
      received_money: { total: 0, count: 0 },
      given_flower: { total: 0, count: 0 },
      received_flower: { total: 0, count: 0 },
    }),
  },
  loading: Boolean,
})

const formatNumber = (num) => {
  if (!num) return '0'
  return Number(num).toLocaleString()
}
</script>

<style scoped>
.summary-card {
  margin-bottom: 12px;
}

.summary-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 16px;
}

.summary-item {
  text-align: center;
  padding: 12px 8px;
  border-radius: 8px;
  background: #f5f7fa;
}

.summary-item.given {
  background: #fef0f0;
}

.summary-item.received {
  background: #f0f9eb;
}

.summary-item.given-flower {
  background: #fdf6ec;
}

.summary-item.received-flower {
  background: #ecf5ff;
}

.summary-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.summary-value {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
}

.summary-count {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}

@media (max-width: 768px) {
  .summary-grid {
    grid-template-columns: 1fr 1fr;
  }

  .summary-value {
    font-size: 15px;
  }
}
</style>
